"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AcdcContext_1 = require("./AcdcContext");
var useAcdcReducer_1 = require("./useAcdcReducer");
function useAcdcOptionProps(index, value, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = AcdcContext_1.useAcdcContext(), dispatch = _a.dispatch, state = _a.state;
    var _b = AcdcContext_1.useAcdcElementRegistryContext(), id = _b.id, registerIndex = _b.registerIndex, unregisterIndex = _b.unregisterIndex, registerOptionElement = _b.registerOptionElement, getInputElement = _b.getInputElement;
    var wrappedDispatch = react_1.useCallback(function (action) {
        if (!opts.disabled) {
            dispatch(action);
        }
    }, [dispatch, opts.disabled]);
    var onMouseEnter = react_1.useCallback(function () { return wrappedDispatch({ type: useAcdcReducer_1.ActionTypes.OptionMouseEnter, index: index, value: value }); }, [wrappedDispatch, index, value]);
    var onMouseLeave = react_1.useCallback(function () { return wrappedDispatch({ type: useAcdcReducer_1.ActionTypes.OptionMouseLeave, index: index, value: value }); }, [wrappedDispatch, index, value]);
    var onClick = react_1.useCallback(function () {
        if (!opts.disabled) {
            var inputElement = getInputElement();
            if (inputElement) {
                inputElement.focus();
            }
        }
        wrappedDispatch({ type: useAcdcReducer_1.ActionTypes.OptionClick, index: index, value: value });
    }, [wrappedDispatch, index, value, opts.disabled, getInputElement]);
    var registerRef = function (instance) {
        registerOptionElement(index, instance);
        if (instance && !opts.disabled) {
            registerIndex(index, value);
        }
        else {
            unregisterIndex(index);
        }
    };
    var mouseHighlightedIndex = state.mouseHighlightedIndex, keyboardHighlightedIndex = state.keyboardHighlightedIndex, selectedIndex = state.selectedIndex;
    var isSelected = index === selectedIndex;
    var isMouseHighlighted = index === mouseHighlightedIndex;
    var isKeyboardHighlighted = index === keyboardHighlightedIndex;
    var isHighlighted = isMouseHighlighted || isKeyboardHighlighted;
    return [
        {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            'id': id + "-option-" + index,
            'ref': registerRef,
            'tabIndex': -1,
            'aria-selected': isKeyboardHighlighted,
            'aria-disabled': opts.disabled,
            'role': 'option',
        },
        {
            isSelected: isSelected,
            isHighlighted: isHighlighted,
            isMouseHighlighted: isMouseHighlighted,
            isKeyboardHighlighted: isKeyboardHighlighted,
        },
    ];
}
exports.default = useAcdcOptionProps;
